/*
  Barista Equip theme-wide fixes. Loaded after theme.js in layout/theme.liquid.

  Auto-playing videos: phones in Low Power Mode or data saver block auto-play, and these
  videos have no controls, so customers saw a frozen frame with nothing to tap. When a
  video is on screen but still has not started after a few seconds, show its play controls.
*/
(() => {
  const WAIT_MS = 3000;

  const watch = (video) => {
    let timer;
    const observer = new IntersectionObserver(([entry]) => {
      clearTimeout(timer);
      if (!entry.isIntersecting) return;

      timer = setTimeout(() => {
        if (!video.paused || video.controls) return;

        video.play()
          .catch(() => {})
          .finally(() => {
            if (!video.paused) return;
            video.controls = true;
            video.closest('video-media')?.classList.add('is-autoplay-blocked');
            observer.disconnect();
          });
      }, WAIT_MS);
    }, { threshold: 0.5 });

    observer.observe(video);
  };

  const init = () => document.querySelectorAll('video-media[autoplay] video').forEach(watch);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

/*
  Main menu hover intent (desktop). The theme opens a mega menu the instant the mouse touches a
  top item, so moving across the bar (for example to the cart) flashes panels open. Like most big
  stores, open only when the pointer slows down over an item; when a panel is already open,
  switching to another item stays instant.
*/
(() => {
  const POLL_MS = 80;       // how often the pointer speed is checked
  const SLOW_PX = 6;        // moved less than this since the last check = resting

  const init = () => {
    document.querySelectorAll('details[is="mega-menu-disclosure"]').forEach((menu) => {
      let poll = null;
      let pass = false;
      let x = 0, y = 0, lastX = null, lastY = null;

      const stop = () => {
        clearInterval(poll);
        poll = null;
        lastX = lastY = null;
      };

      const open = () => {
        stop();
        pass = true;
        menu.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
        pass = false;
      };

      menu.addEventListener('mousemove', (event) => {
        x = event.clientX;
        y = event.clientY;
      });

      menu.addEventListener('mouseover', (event) => {
        if (pass || menu.open || menu.trigger !== 'hover') return;
        if (menu.closest('ul')?.querySelector('details[open]')) return;

        event.stopImmediatePropagation();
        x = event.clientX;
        y = event.clientY;
        if (poll) return;

        poll = setInterval(() => {
          if (lastX !== null && Math.hypot(x - lastX, y - lastY) < SLOW_PX) {
            open();
            return;
          }
          lastX = x;
          lastY = y;
        }, POLL_MS);
      }, true);

      menu.addEventListener('mouseleave', stop);
    });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
